<template>
	<headless-modal
		ref="imageModal"
		id="imageModal"
		:title="`${categoryTitle} - ${item['title']}`"
		title-class="!text-2xl !font-light text-center !mt-4 !mb-0 !pb-0"
		:btn-text="item['title']"
		hide-btn
		hybrid-btn
	>
		<template v-slot:content>
			<div class="flex flex-col items-center justify-center gap-4">
				<figure>
					<video
						v-if="item.productImage.mimeType?.includes('video')"
						:src="item.productImage.src"
						autoplay
						loop
						muted
						playsinline
					/>
					<img v-else :src="item.productImage.src" :alt="item.title" class="w-full object-contain" />
				</figure>
				<button
					type="button"
					class="bg-black text-white uppercase h-12 text-xs w-full font-medium tracking-wider"
					@click="handleModalIncrement"
					:disabled="disabled || isVariantIncrementDisabled(id)"
					aria-label="Add To Palette"
				>
					Add To Palette
				</button>
			</div>
		</template>
		<template v-slot:button>
			<div
				:style="{
					backgroundImage: item.hasSwatch ? `url('${item.swatchUrl}')` : 'none',
					backgroundColor: !item.hasSwatch ? item.hex : '#f5f5f5',
				}"
				class="h-20 w-20 rounded-xl border-swatch !border-stone-300 bg-cover bg-center bg-no-repeat text-transparent"
			/>
		</template>
	</headless-modal>
	<div class="flex flex-col justify-between">
		<slot name="info" />
		<div class="w-[84px] grid grid-cols-[32px_1fr_32px]">
			<button
				@click="handleDecrement"
				:disabled="disabled || isVariantDecrementDisabled(id)"
				class="flex item-center h-fit flex-col justify-center hover:bg-zinc-100 disabled:opacity-25 disabled:pointer-events-none"
				aria-label="Decrement Quantity"
			>
				<svg-vue icon="minus-icon" class="w-6 h-6 stroke-black fill-white mx-auto" />
			</button>
			<input
				v-if="items[id]"
				type="text"
				v-model="items[id].quantity"
				read-only
				class="pointer-events-none !h-fit !border-none !p-0 text-center !text-black"
			/>
			<button
				@click="handleIncrement"
				:disabled="disabled || isVariantIncrementDisabled(id)"
				class="flex flex-col h-fit item-center justify-center hover:bg-zinc-100 disabled:opacity-25 disabled:pointer-events-none"
				aria-label="Increment Quantity"
			>
				<svg-vue icon="plus-icon" class="w-6 h-6 stroke-black fill-white mx-auto" />
			</button>
		</div>
	</div>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import { storeToRefs } from 'pinia'

import { usePaletteBuilderStore } from '@stores'

const props = defineProps({
	categoryTitle: {
		type: String,
		required: true,
	},
	item: {
		type: Object,
		required: true,
	},
	disabled: {
		type: Boolean,
		default: false,
	},
})

const store = usePaletteBuilderStore()
const { items, isVariantDecrementDisabled, isVariantIncrementDisabled } = storeToRefs(store)
const { setItem, incrementItemQuantity, decrementItemQuantity } = store

const id = ref(props.item.id)
const imageModal = ref(null)

onMounted(() => {
	setItem(props.item, props.categoryTitle)
})

const handleDecrement = () => decrementItemQuantity(id.value)
const handleModalIncrement = () => {
	handleIncrement()
	imageModal.value.setIsOpen(false)
}
const handleIncrement = () => incrementItemQuantity(id.value)
</script>
